import {
  SiMysql,
  SiPwa,
  SiWebpack,
  SiJavascript,
  SiCss3,
  SiHtml5,
  SiBootstrap,
  SiReact,
  SiTailwindcss,
  SiPhp,
  SiRedux,
  SiMongodb,
  SiExpress,
  SiNodedotjs,
} from 'react-icons/si';

const react_logo = <SiReact className="w-7 h-7 text-[#00abfb]" />;
const tailwind_logo = <SiTailwindcss className="w-8 h-8 text-[#00abfb]" />;
const html_logo = <SiHtml5 className="w-5 h-5 text-[#00abfb]" />;
const css_logo = <SiCss3 className="w-5 h-5 text-[#00abfb]" />;
const bs_logo = <SiBootstrap className="w-7 h-7 text-[#00abfb]" />;
const js_logo = <SiJavascript className="w-5 h-5 text-[#00abfb]" />;
const php_logo = <SiPhp className="w-8 h-8 text-[#00abfb]" />;
const mysql_logo = <SiMysql className="w-9 h-9 text-[#00abfb]" />;
const webpack_logo = <SiWebpack className="w-5 h-5 text-[#00abfb]" />;
const pwa_logo = <SiPwa className="w-8 h-8 text-[#00abfb]" />;
const redux_logo = <SiRedux className="w-6 h-6 text-[#00abfb]" />;
const hapi_logo = <h1 className="text-xl font-bold text-[#00abfb]">Hapi</h1>;
const mongo_db = <SiMongodb className="w-6 h-6 text-[#00abfb]" />;
const express = <SiExpress className="w-6 h-6 text-[#00abfb]" />;
const node = <SiNodedotjs className="w-6 h-6 text-[#00abfb]" />;

export {
  react_logo,
  tailwind_logo,
  html_logo,
  css_logo,
  js_logo,
  bs_logo,
  php_logo,
  mysql_logo,
  webpack_logo,
  pwa_logo,
  redux_logo,
  hapi_logo,
  mongo_db,
  express,
  node,
};
